import { SaveColorButtonsWrapper, SaveColorProvider } from "~/react/save-color";
import { useColourPaletteStore } from "~/js/stores/colour-palette-store";
import { useColourMatched } from "~/js/api/colour-palette/get-colour-matched";
import { useEffect } from "react";

export function ColourChip()  {
  const rgbCode = useColourPaletteStore((state) => state.rgbCode);
  const setColourCode = useColourPaletteStore((state) => state.setColourCode);
  const { data, isError } = useColourMatched(rgbCode);

  useEffect(() => {
    if(data?.colourCode) {
      setColourCode(data?.colourCode);
    }
  }, [data]);

  return (
        <div className="colour-chip colour-chip-expand ">
          {!isError && !!data && (
            <div className="colour-chip-inner">
              <div className="colour-chip-colour"
                   onClick={(e) => {
                     if(!data || !data?.url) return;
                     if(e.target === e.currentTarget) window.location.href = data?.url;
                   }}
                   style={{
                      backgroundColor: "rgb(" + data?.colourRGB + ")",
                      color: "rgba(" + data?.colourRGB + ", .6)"
                    }}
              >
                {!!data && !!data?.colourActions && (
                  <SaveColorProvider data={data?.colourActions}>
                    <SaveColorButtonsWrapper />
                  </SaveColorProvider>
                )}
              </div>
              <div className="colour-chip-info">
                <p className="colour">{data?.colourName}</p>
                <p>{data?.colourCode}</p>
              </div>
            </div>
          )}
        </div>
  );
}
